import noti from '../../../assets/images/feature/feature-homeBanner-02.png';
import rateCalc from '../../../assets/images/feature/feature-homeBanner-03.png';
import BANNER_01 from '../../../assets/images/feature/feature-homeBanner-01.png';
import rateCalc2 from '../../../assets/images/feature/feature-ratecalc.png';
import reqList from '../../../assets/images/feature/feature-reqlist.png';
import mgtIcon from '../../../assets/images/feature/feature-rateCalcResult-banner-03.png';
import creditIcon from '../../../assets/images/feature/feature-credit-loan-icon.png';

import { ClkBtnSubEventNm } from '../../hooks/useBeacon';
import { IS_MTG_EXPOSED } from '../../types/types';

export const HOME_DEFAULT_SIMPLE_LIST = [
  ...(IS_MTG_EXPOSED
    ? [
        {
          headerText: '주택담보대출',
          subheaderText: '',
          avatar: {
            size: 'lg',
            border: false,
            state: 'enabled',
            source: mgtIcon,
            alt: '주택담보대출',
          },
          beacon: {
            subEventName: ClkBtnSubEventNm.GoMtgMain,
            buttonName: '주택담보대출',
          },
          navigate: {
            destination: '/mtgMain',
          },
        },
      ]
    : []),
  {
    headerText: '신용대출 비교',
    subheaderText: '',
    avatar: {
      size: 'lg',
      border: false,
      state: 'enabled',
      source: creditIcon,
      alt: '신용대출 비교',
    },
    beacon: {
      subEventName: ClkBtnSubEventNm.GoCreMain,
      buttonName: '신용대출 비교',
    },
    navigate: {
      destination: '/main',
    },
  },
];

export const HOME_BANNER_MTG = [
  {
    headerText: '대출 신청내역',
    subheaderText: '',
    avatar: {
      size: 'lg',
      border: false,
      state: 'enabled',
      source: reqList,
      alt: '대출 신청내역',
    },
    beacon: {
      subEventName: ClkBtnSubEventNm.GoReqList,
      buttonName: '대출 신청내역',
    },
    navigate: {
      destination: '/mtg/result-status',
    },
  },
  {
    headerText: '이자 계산기',
    subheaderText: '',
    avatar: {
      size: 'lg',
      border: false,
      state: 'enabled',
      source: rateCalc2,
      alt: '이자 계산기',
    },
    beacon: {
      subEventName: ClkBtnSubEventNm.IntrstCalc,
      buttonName: '이자 계산기',
    },
    navigate: {
      destination: '/mtg/rateCalc',
    },
  },
];

export const HOME_BANNER = [
  // {
  //   headerText: '정기 알림 서비스',
  //   subheaderText: '매월 자동으로 심사를 받아보세요',
  //   avatar: {
  //     size: 'lg',
  //     border: false,
  //     state: 'enabled',
  //     source: noti,
  //     alt: '정기 알림 서비스',
  //   },
  // },
  {
    headerText: '이자 계산기',
    subheaderText: '매월 상환 금액을 계산해보세요',
    avatar: {
      size: 'lg',
      border: false,
      state: 'enabled',
      source: rateCalc,
      alt: '이자 계산기',
    },
  },
];

export const HOME_BANNER2 = [
  {
    headerText: '대출 진행 현황',
    subheaderText: '최근 1달간 나의 기록이에요',
    avatar: {
      size: 'lg',
      border: false,
      state: 'enabled',
      source: BANNER_01,
      alt: '대출 진행 현황',
    },
  },
  // {
  //   headerText: '정기 알림 서비스',
  //   subheaderText: '매월 알림을 받아보세요',
  //   avatar: {
  //     size: 'lg',
  //     border: false,
  //     state: 'enabled',
  //     source: noti,
  //     alt: '정기 알림 서비스',
  //   },
  // },
  {
    headerText: '이자 계산기',
    subheaderText: '매월 상환 금액을 계산해보세요',
    avatar: {
      size: 'lg',
      border: false,
      state: 'enabled',
      source: rateCalc,
      alt: '이자 계산기',
    },
  },
];
